// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UJ0T","question":"styles_question__1cQ-_","description":"styles_description__1BmDA"};